var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _path, _path2, _path3, _path4, _path5, _g49, _g50, _g51, _g52, _g53, _g54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    zoomAndPan: "magnify",
    viewBox: "0 0 600 1499.999933",
    height: 2000,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd62b655dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 313.726562 L 540 313.726562 L 540 474.9375 L 79.316406 474.9375 Z M 79.316406 313.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1ca76a65c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.324219 313.726562 L 539.816406 313.726562 L 539.816406 474.929688 L 79.324219 474.929688 Z M 79.324219 313.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d442f21806"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 869.363281 L 540 869.363281 L 540 1030.578125 L 79.316406 1030.578125 Z M 79.316406 869.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf1f3da1a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.324219 869.363281 L 539.816406 869.363281 L 539.816406 1030.566406 L 79.324219 1030.566406 Z M 79.324219 869.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "01de7f10d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 498.9375 L 540 498.9375 L 540 660.152344 L 79.316406 660.152344 Z M 79.316406 498.9375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1730a13f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.324219 498.9375 L 539.816406 498.9375 L 539.816406 660.140625 L 79.324219 660.140625 Z M 79.324219 498.9375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "170d910e27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1054.578125 L 540 1054.578125 L 540 1215.789062 L 79.316406 1215.789062 Z M 79.316406 1054.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f03b2c4eee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.324219 1054.578125 L 539.816406 1054.578125 L 539.816406 1215.78125 L 79.324219 1215.78125 Z M 79.324219 1054.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "06e513b141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 684.152344 L 540 684.152344 L 540 845.363281 L 79.316406 845.363281 Z M 79.316406 684.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c2e30a747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.324219 684.152344 L 539.816406 684.152344 L 539.816406 845.355469 L 79.324219 845.355469 Z M 79.324219 684.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "103f26a348"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1239.789062 L 540 1239.789062 L 540 1401.003906 L 79.316406 1401.003906 Z M 79.316406 1239.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4c23dec718"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.324219 1239.789062 L 539.816406 1239.789062 L 539.816406 1400.992188 L 79.324219 1400.992188 Z M 79.324219 1239.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13b40423d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 313.726562 L 540 313.726562 L 540 373.765625 L 79.316406 373.765625 Z M 79.316406 313.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44400bba17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.332031 313.726562 L 539.816406 313.726562 L 539.816406 373.726562 L 79.332031 373.726562 Z M 79.332031 313.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "726818c0fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 869.363281 L 540 869.363281 L 540 929.402344 L 79.316406 929.402344 Z M 79.316406 869.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "83466ffa5d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.332031 869.363281 L 539.816406 869.363281 L 539.816406 929.363281 L 79.332031 929.363281 Z M 79.332031 869.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "78b0d55ebe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 498.9375 L 540 498.9375 L 540 558.980469 L 79.316406 558.980469 Z M 79.316406 498.9375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f11cfa2172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.332031 498.9375 L 539.816406 498.9375 L 539.816406 558.9375 L 79.332031 558.9375 Z M 79.332031 498.9375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c6ee503de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1054.578125 L 540 1054.578125 L 540 1114.617188 L 79.316406 1114.617188 Z M 79.316406 1054.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b4e8a22f65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.332031 1054.578125 L 539.816406 1054.578125 L 539.816406 1114.578125 L 79.332031 1114.578125 Z M 79.332031 1054.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0352748d6d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 684.152344 L 540 684.152344 L 540 744.191406 L 79.316406 744.191406 Z M 79.316406 684.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "52086340b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.332031 684.152344 L 539.816406 684.152344 L 539.816406 744.152344 L 79.332031 744.152344 Z M 79.332031 684.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53bc30ae60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1239.789062 L 540 1239.789062 L 540 1299.828125 L 79.316406 1299.828125 Z M 79.316406 1239.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "50c836fc50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.332031 1239.789062 L 539.816406 1239.789062 L 539.816406 1299.789062 L 79.332031 1299.789062 Z M 79.332031 1239.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d73f6231a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 313.726562 L 153.6875 313.726562 L 153.6875 474.9375 L 79.316406 474.9375 Z M 79.316406 313.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d881bb1745"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 313.726562 L 153.566406 313.726562 L 153.566406 474.929688 L 79.316406 474.929688 Z M 79.316406 313.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "55480a61f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 869.363281 L 153.6875 869.363281 L 153.6875 1030.578125 L 79.316406 1030.578125 Z M 79.316406 869.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44109d6e27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 869.363281 L 153.566406 869.363281 L 153.566406 1030.566406 L 79.316406 1030.566406 Z M 79.316406 869.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "76ca06d927"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 498.9375 L 153.6875 498.9375 L 153.6875 660.152344 L 79.316406 660.152344 Z M 79.316406 498.9375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "50c98624e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 498.9375 L 153.566406 498.9375 L 153.566406 660.140625 L 79.316406 660.140625 Z M 79.316406 498.9375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "729ef65a2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1054.578125 L 153.6875 1054.578125 L 153.6875 1215.789062 L 79.316406 1215.789062 Z M 79.316406 1054.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "921fe9ba23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1054.578125 L 153.566406 1054.578125 L 153.566406 1215.78125 L 79.316406 1215.78125 Z M 79.316406 1054.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "567641b554"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 684.152344 L 153.6875 684.152344 L 153.6875 845.363281 L 79.316406 845.363281 Z M 79.316406 684.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5b9d24a30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 684.152344 L 153.566406 684.152344 L 153.566406 845.355469 L 79.316406 845.355469 Z M 79.316406 684.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aec2cd8f3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1239.789062 L 153.6875 1239.789062 L 153.6875 1401.003906 L 79.316406 1401.003906 Z M 79.316406 1239.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ca39557b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1239.789062 L 153.566406 1239.789062 L 153.566406 1400.992188 L 79.316406 1400.992188 Z M 79.316406 1239.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3e38f9d8c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 357.3125 L 153.351562 357.3125 L 153.351562 431.351562 L 79.316406 431.351562 Z M 79.316406 357.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "89494d92de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.332031 357.3125 C 95.890625 357.3125 79.316406 373.886719 79.316406 394.332031 C 79.316406 414.777344 95.890625 431.351562 116.332031 431.351562 C 136.777344 431.351562 153.351562 414.777344 153.351562 394.332031 C 153.351562 373.886719 136.777344 357.3125 116.332031 357.3125 Z M 116.332031 357.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b22c63438"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 357.3125 L 153.34375 357.3125 L 153.34375 431.339844 L 79.316406 431.339844 Z M 79.316406 357.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9ff2e589d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.328125 357.3125 C 95.886719 357.3125 79.316406 373.886719 79.316406 394.328125 C 79.316406 414.769531 95.886719 431.339844 116.328125 431.339844 C 136.769531 431.339844 153.34375 414.769531 153.34375 394.328125 C 153.34375 373.886719 136.769531 357.3125 116.328125 357.3125 Z M 116.328125 357.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "109149061b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 912.953125 L 153.351562 912.953125 L 153.351562 986.988281 L 79.316406 986.988281 Z M 79.316406 912.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "78cf9a2000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.332031 912.953125 C 95.890625 912.953125 79.316406 929.527344 79.316406 949.96875 C 79.316406 970.414062 95.890625 986.988281 116.332031 986.988281 C 136.777344 986.988281 153.351562 970.414062 153.351562 949.96875 C 153.351562 929.527344 136.777344 912.953125 116.332031 912.953125 Z M 116.332031 912.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4202dad8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 912.953125 L 153.34375 912.953125 L 153.34375 986.980469 L 79.316406 986.980469 Z M 79.316406 912.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "14e068ad0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.328125 912.953125 C 95.886719 912.953125 79.316406 929.523438 79.316406 949.964844 C 79.316406 970.40625 95.886719 986.980469 116.328125 986.980469 C 136.769531 986.980469 153.34375 970.40625 153.34375 949.964844 C 153.34375 929.523438 136.769531 912.953125 116.328125 912.953125 Z M 116.328125 912.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f41735b46b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 542.527344 L 153.351562 542.527344 L 153.351562 616.5625 L 79.316406 616.5625 Z M 79.316406 542.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "773785400f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.332031 542.527344 C 95.890625 542.527344 79.316406 559.101562 79.316406 579.546875 C 79.316406 599.988281 95.890625 616.5625 116.332031 616.5625 C 136.777344 616.5625 153.351562 599.988281 153.351562 579.546875 C 153.351562 559.101562 136.777344 542.527344 116.332031 542.527344 Z M 116.332031 542.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2328df2eb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 542.527344 L 153.34375 542.527344 L 153.34375 616.554688 L 79.316406 616.554688 Z M 79.316406 542.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "125ae18380"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.328125 542.527344 C 95.886719 542.527344 79.316406 559.097656 79.316406 579.539062 C 79.316406 599.984375 95.886719 616.554688 116.328125 616.554688 C 136.769531 616.554688 153.34375 599.984375 153.34375 579.539062 C 153.34375 559.097656 136.769531 542.527344 116.328125 542.527344 Z M 116.328125 542.527344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "917b101e39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1098.164062 L 153.351562 1098.164062 L 153.351562 1172.199219 L 79.316406 1172.199219 Z M 79.316406 1098.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "82a7ae0fc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.332031 1098.164062 C 95.890625 1098.164062 79.316406 1114.738281 79.316406 1135.183594 C 79.316406 1155.628906 95.890625 1172.199219 116.332031 1172.199219 C 136.777344 1172.199219 153.351562 1155.628906 153.351562 1135.183594 C 153.351562 1114.738281 136.777344 1098.164062 116.332031 1098.164062 Z M 116.332031 1098.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed8748f472"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1098.164062 L 153.34375 1098.164062 L 153.34375 1172.191406 L 79.316406 1172.191406 Z M 79.316406 1098.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5c426754f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.328125 1098.164062 C 95.886719 1098.164062 79.316406 1114.738281 79.316406 1135.179688 C 79.316406 1155.621094 95.886719 1172.191406 116.328125 1172.191406 C 136.769531 1172.191406 153.34375 1155.621094 153.34375 1135.179688 C 153.34375 1114.738281 136.769531 1098.164062 116.328125 1098.164062 Z M 116.328125 1098.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "32293d7a7f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 727.738281 L 153.351562 727.738281 L 153.351562 801.773438 L 79.316406 801.773438 Z M 79.316406 727.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7d2d8ff57b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.332031 727.738281 C 95.890625 727.738281 79.316406 744.3125 79.316406 764.757812 C 79.316406 785.203125 95.890625 801.777344 116.332031 801.777344 C 136.777344 801.777344 153.351562 785.203125 153.351562 764.757812 C 153.351562 744.3125 136.777344 727.738281 116.332031 727.738281 Z M 116.332031 727.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2353853e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 727.738281 L 153.34375 727.738281 L 153.34375 801.765625 L 79.316406 801.765625 Z M 79.316406 727.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db735045b6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.328125 727.738281 C 95.886719 727.738281 79.316406 744.3125 79.316406 764.753906 C 79.316406 785.195312 95.886719 801.765625 116.328125 801.765625 C 136.769531 801.765625 153.34375 785.195312 153.34375 764.753906 C 153.34375 744.3125 136.769531 727.738281 116.328125 727.738281 Z M 116.328125 727.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "345204a1d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1283.378906 L 153.351562 1283.378906 L 153.351562 1357.414062 L 79.316406 1357.414062 Z M 79.316406 1283.378906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4e0f87ecb9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.332031 1283.378906 C 95.890625 1283.378906 79.316406 1299.953125 79.316406 1320.394531 C 79.316406 1340.839844 95.890625 1357.414062 116.332031 1357.414062 C 136.777344 1357.414062 153.351562 1340.839844 153.351562 1320.394531 C 153.351562 1299.953125 136.777344 1283.378906 116.332031 1283.378906 Z M 116.332031 1283.378906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a498c82f40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.316406 1283.378906 L 153.34375 1283.378906 L 153.34375 1357.40625 L 79.316406 1357.40625 Z M 79.316406 1283.378906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "addb55dfb0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.328125 1283.378906 C 95.886719 1283.378906 79.316406 1299.949219 79.316406 1320.390625 C 79.316406 1340.832031 95.886719 1357.40625 116.328125 1357.40625 C 136.769531 1357.40625 153.34375 1340.832031 153.34375 1320.390625 C 153.34375 1299.949219 136.769531 1283.378906 116.328125 1283.378906 Z M 116.328125 1283.378906 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -60,
    width: 720,
    fill: "#ffffff",
    y: -149.999993,
    height: 1799.99992,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -60,
    width: 720,
    fill: "#ffc4d0",
    y: -149.999993,
    height: 1799.99992,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd62b655dc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc4d0",
    d: "M 79.316406 313.726562 L 540.28125 313.726562 L 540.28125 474.9375 L 79.316406 474.9375 Z M 79.316406 313.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1ca76a65c)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.324987, 313.725891)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00102368 0.00089483 L 614.207402 0.00089483 L 614.207402 214.938427 L -0.00102368 214.938427 Z M -0.00102368 0.00089483 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d442f21806)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc4d0",
    d: "M 79.316406 869.363281 L 540.28125 869.363281 L 540.28125 1030.578125 L 79.316406 1030.578125 Z M 79.316406 869.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf1f3da1a1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.324987, 869.363809)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00102368 -0.000703825 L 614.207402 -0.000703825 L 614.207402 214.936828 L -0.00102368 214.936828 Z M -0.00102368 -0.000703825 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#01de7f10d1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc4d0",
    d: "M 79.316406 498.9375 L 540.28125 498.9375 L 540.28125 660.152344 L 79.316406 660.152344 Z M 79.316406 498.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1730a13f8)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.324987, 498.938385)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00102368 -0.00118003 L 614.207402 -0.00118003 L 614.207402 214.936352 L -0.00102368 214.936352 Z M -0.00102368 -0.00118003 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#170d910e27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc4d0",
    d: "M 79.316406 1054.578125 L 540.28125 1054.578125 L 540.28125 1215.789062 L 79.316406 1215.789062 Z M 79.316406 1054.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f03b2c4eee)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.324987, 1054.576761)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00102368 0.00181845 L 614.207402 0.00181845 L 614.207402 214.939351 L -0.00102368 214.939351 Z M -0.00102368 0.00181845 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#06e513b141)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc4d0",
    d: "M 79.316406 684.152344 L 540.28125 684.152344 L 540.28125 845.363281 L 79.316406 845.363281 Z M 79.316406 684.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c2e30a747)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.324987, 684.151337)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00102368 0.00134224 L 614.207402 0.00134224 L 614.207402 214.938875 L -0.00102368 214.938875 Z M -0.00102368 0.00134224 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#103f26a348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc4d0",
    d: "M 79.316406 1239.789062 L 540.28125 1239.789062 L 540.28125 1401.003906 L 79.316406 1401.003906 Z M 79.316406 1239.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4c23dec718)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.324987, 1239.789257)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00102368 -0.000259617 L 614.207402 -0.000259617 L 614.207402 214.937273 L -0.00102368 214.937273 Z M -0.00102368 -0.000259617 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13b40423d7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 313.726562 L 539.9375 313.726562 L 539.9375 373.765625 L 79.316406 373.765625 Z M 79.316406 313.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44400bba17)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.331191, 313.725891)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00112099 0.00089483 L 614.193882 0.00089483 L 614.193882 80.047777 L 0.00112099 80.047777 Z M 0.00112099 0.00089483 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#726818c0fd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 869.363281 L 539.9375 869.363281 L 539.9375 929.402344 L 79.316406 929.402344 Z M 79.316406 869.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#83466ffa5d)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.331191, 869.363809)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00112099 -0.000703825 L 614.193882 -0.000703825 L 614.193882 80.046178 L 0.00112099 80.046178 Z M 0.00112099 -0.000703825 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#78b0d55ebe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 498.9375 L 539.9375 498.9375 L 539.9375 558.980469 L 79.316406 558.980469 Z M 79.316406 498.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f11cfa2172)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.331191, 498.938385)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00112099 -0.00118003 L 614.193882 -0.00118003 L 614.193882 80.045702 L 0.00112099 80.045702 Z M 0.00112099 -0.00118003 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c6ee503de)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 1054.578125 L 539.9375 1054.578125 L 539.9375 1114.617188 L 79.316406 1114.617188 Z M 79.316406 1054.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b4e8a22f65)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.331191, 1054.576761)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00112099 0.00181845 L 614.193882 0.00181845 L 614.193882 80.0487 L 0.00112099 80.0487 Z M 0.00112099 0.00181845 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0352748d6d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 684.152344 L 539.9375 684.152344 L 539.9375 744.191406 L 79.316406 744.191406 Z M 79.316406 684.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52086340b2)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.331191, 684.151337)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00112099 0.00134224 L 614.193882 0.00134224 L 614.193882 80.048224 L 0.00112099 80.048224 Z M 0.00112099 0.00134224 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53bc30ae60)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 1239.789062 L 539.9375 1239.789062 L 539.9375 1299.828125 L 79.316406 1299.828125 Z M 79.316406 1239.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50c836fc50)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.331191, 1239.789257)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00112099 -0.000259617 L 614.193882 -0.000259617 L 614.193882 80.046622 L 0.00112099 80.046622 Z M 0.00112099 -0.000259617 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d73f6231a2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb577c",
    d: "M 79.316406 313.726562 L 153.6875 313.726562 L 153.6875 474.957031 L 79.316406 474.957031 Z M 79.316406 313.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d881bb1745)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.316191, 313.725891)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000287656 0.00089483 L 99.156553 0.00089483 L 99.156553 214.938427 L 0.000287656 214.938427 Z M 0.000287656 0.00089483 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#55480a61f7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb577c",
    d: "M 79.316406 869.363281 L 153.6875 869.363281 L 153.6875 1030.597656 L 79.316406 1030.597656 Z M 79.316406 869.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44109d6e27)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.316191, 869.363809)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000287656 -0.000703825 L 99.156553 -0.000703825 L 99.156553 214.936828 L 0.000287656 214.936828 Z M 0.000287656 -0.000703825 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76ca06d927)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb577c",
    d: "M 79.316406 498.9375 L 153.6875 498.9375 L 153.6875 660.171875 L 79.316406 660.171875 Z M 79.316406 498.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50c98624e7)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.316191, 498.938385)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000287656 -0.00118003 L 99.156553 -0.00118003 L 99.156553 214.936352 L 0.000287656 214.936352 Z M 0.000287656 -0.00118003 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#729ef65a2d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb577c",
    d: "M 79.316406 1054.578125 L 153.6875 1054.578125 L 153.6875 1215.808594 L 79.316406 1215.808594 Z M 79.316406 1054.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#921fe9ba23)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.316191, 1054.576761)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000287656 0.00181845 L 99.156553 0.00181845 L 99.156553 214.939351 L 0.000287656 214.939351 Z M 0.000287656 0.00181845 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#567641b554)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb577c",
    d: "M 79.316406 684.152344 L 153.6875 684.152344 L 153.6875 845.382812 L 79.316406 845.382812 Z M 79.316406 684.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b5b9d24a30)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.316191, 684.151337)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000287656 0.00134224 L 99.156553 0.00134224 L 99.156553 214.938875 L 0.000287656 214.938875 Z M 0.000287656 0.00134224 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aec2cd8f3d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb577c",
    d: "M 79.316406 1239.789062 L 153.6875 1239.789062 L 153.6875 1401.023438 L 79.316406 1401.023438 Z M 79.316406 1239.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3ca39557b4)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.316191, 1239.789257)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000287656 -0.000259617 L 99.156553 -0.000259617 L 99.156553 214.937273 L 0.000287656 214.937273 Z M 0.000287656 -0.000259617 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e38f9d8c9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#89494d92de)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 357.3125 L 153.351562 357.3125 L 153.351562 431.351562 L 79.316406 431.351562 Z M 79.316406 357.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b22c63438)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9ff2e589d5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.315591, 357.314011)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 49.35005 -0.00201443 C 22.09484 -0.00201443 0.00108766 22.096946 0.00108766 49.352156 C 0.00108766 76.607367 22.09484 98.701119 49.35005 98.701119 C 76.605261 98.701119 98.704221 76.607367 98.704221 49.352156 C 98.704221 22.096946 76.605261 -0.00201443 49.35005 -0.00201443 Z M 49.35005 -0.00201443 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#109149061b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#78cf9a2000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 912.953125 L 153.351562 912.953125 L 153.351562 986.988281 L 79.316406 986.988281 Z M 79.316406 912.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4202dad8c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#14e068ad0d)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.315591, 912.951933)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 49.35005 0.00158885 C 22.09484 0.00158885 0.00108766 22.095341 0.00108766 49.350551 C 0.00108766 76.605762 22.09484 98.704722 49.35005 98.704722 C 76.605261 98.704722 98.704221 76.605762 98.704221 49.350551 C 98.704221 22.095341 76.605261 0.00158885 49.35005 0.00158885 Z M 49.35005 0.00158885 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f41735b46b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#773785400f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 542.527344 L 153.351562 542.527344 L 153.351562 616.5625 L 79.316406 616.5625 Z M 79.316406 542.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2328df2eb7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#125ae18380)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.315591, 542.526965)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 49.35005 0.00050464 C 22.09484 0.00050464 0.00108766 22.094257 0.00108766 49.349467 C 0.00108766 76.609886 22.09484 98.703638 49.35005 98.703638 C 76.605261 98.703638 98.704221 76.609886 98.704221 49.349467 C 98.704221 22.094257 76.605261 0.00050464 49.35005 0.00050464 Z M 49.35005 0.00050464 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#917b101e39)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#82a7ae0fc4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 1098.164062 L 153.351562 1098.164062 L 153.351562 1172.199219 L 79.316406 1172.199219 Z M 79.316406 1098.164062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed8748f472)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5c426754f1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.315591, 1098.164885)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 49.35005 -0.00109722 C 22.09484 -0.00109722 0.00108766 22.097863 0.00108766 49.353074 C 0.00108766 76.608284 22.09484 98.702036 49.35005 98.702036 C 76.605261 98.702036 98.704221 76.608284 98.704221 49.353074 C 98.704221 22.097863 76.605261 -0.00109722 49.35005 -0.00109722 Z M 49.35005 -0.00109722 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#32293d7a7f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d2d8ff57b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 727.738281 L 153.351562 727.738281 L 153.351562 801.773438 L 79.316406 801.773438 Z M 79.316406 727.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2353853e4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db735045b6)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.315591, 727.739437)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 49.35005 -0.00154142 C 22.09484 -0.00154142 0.00108766 22.097419 0.00108766 49.352629 C 0.00108766 76.60784 22.09484 98.701592 49.35005 98.701592 C 76.605261 98.701592 98.704221 76.60784 98.704221 49.352629 C 98.704221 22.097419 76.605261 -0.00154142 49.35005 -0.00154142 Z M 49.35005 -0.00154142 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#345204a1d9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4e0f87ecb9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0e0",
    d: "M 79.316406 1283.378906 L 153.351562 1283.378906 L 153.351562 1357.414062 L 79.316406 1357.414062 Z M 79.316406 1283.378906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a498c82f40)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#addb55dfb0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 79.315591, 1283.377837)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 49.35005 0.00142506 C 22.09484 0.00142506 0.00108766 22.095177 0.00108766 49.350388 C 0.00108766 76.605598 22.09484 98.704559 49.35005 98.704559 C 76.605261 98.704559 98.704221 76.605598 98.704221 49.350388 C 98.704221 22.095177 76.605261 0.00142506 49.35005 0.00142506 Z M 49.35005 0.00142506 ",
    stroke: "#000000",
    strokeWidth: 3,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.75, -0.75, 0, 116.708067, 431.913231)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00110894 0.501381 L 147.485497 0.501381 ",
    stroke: "#4a3222",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.75, -0.75, 0, 116.708067, 617.125703)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000937127 0.501381 L 147.483451 0.501381 ",
    stroke: "#4a3222",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.75, -0.75, 0, 116.708067, 802.338199)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00219314 0.501381 L 147.486581 0.501381 ",
    stroke: "#4a3222",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.75, -0.75, 0, 116.708067, 987.551607)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00110092 0.501381 L 147.483287 0.501381 ",
    stroke: "#4a3222",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.75, -0.75, 0, 116.708067, 1172.764103)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00202935 0.501381 L 147.486417 0.501381 ",
    stroke: "#4a3222",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb577c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.058016, 405.582132)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.289062 -14.089844 C 4.316406 -13.621094 4.339844 -13.207031 4.339844 -12.761719 C 4.339844 -10.839844 4.394531 -8.917969 4.472656 -6.992188 C 4.496094 -6.1875 4.472656 -5.382812 4.472656 -4.574219 C 4.472656 -3.5625 4.445312 -2.574219 4.445312 -1.585938 L 4.445312 -0.363281 C 4.445312 -0.078125 4.679688 0.128906 4.964844 0.105469 C 5.121094 0.078125 5.25 0.078125 5.40625 0.078125 L 7.199219 0.078125 C 7.304688 0.078125 7.382812 0.078125 7.488281 0.0507812 C 7.695312 -0.0273438 7.796875 -0.15625 7.796875 -0.390625 C 7.796875 -1.066406 7.773438 -1.742188 7.773438 -2.417969 C 7.796875 -3.457031 7.824219 -4.496094 7.824219 -5.535156 C 7.824219 -7.667969 7.796875 -9.773438 7.796875 -11.878906 C 7.796875 -12.996094 7.773438 -14.089844 7.667969 -15.207031 C 7.640625 -15.648438 7.640625 -16.117188 7.640625 -16.558594 C 7.640625 -16.792969 7.667969 -17 7.667969 -17.207031 C 7.695312 -17.417969 7.695312 -17.597656 7.695312 -17.78125 L 7.695312 -18.144531 C 7.667969 -18.273438 7.566406 -18.351562 7.433594 -18.378906 C 7.226562 -18.40625 7.019531 -18.429688 6.8125 -18.429688 C 6.160156 -18.457031 5.511719 -18.457031 4.859375 -18.457031 C 4.601562 -18.484375 4.394531 -18.378906 4.210938 -18.195312 C 4.132812 -18.117188 4.027344 -18.039062 3.925781 -17.960938 C 3.5625 -17.652344 3.199219 -17.3125 2.832031 -17.027344 C 2.445312 -16.714844 2.054688 -16.453125 1.691406 -16.195312 L 1.300781 -15.882812 C 1.144531 -15.777344 1.066406 -15.621094 1.066406 -15.441406 C 1.066406 -15.363281 1.039062 -15.285156 1.039062 -15.234375 C 1.066406 -14.6875 1.066406 -14.140625 1.089844 -13.59375 C 1.089844 -13.285156 1.144531 -12.972656 1.222656 -12.660156 C 1.273438 -12.347656 1.535156 -12.242188 1.820312 -12.425781 C 2.3125 -12.761719 2.859375 -13.023438 3.328125 -13.4375 C 3.40625 -13.515625 3.507812 -13.542969 3.613281 -13.621094 L 4.082031 -13.933594 C 4.132812 -13.984375 4.210938 -14.039062 4.289062 -14.089844 Z M 4.289062 -14.089844 "
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb577c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.690829, 961.220057)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.800781 -12.917969 C 9.773438 -13.882812 9.75 -14.867188 9.722656 -15.832031 L 9.644531 -18.015625 C 9.617188 -18.351562 9.59375 -18.378906 9.253906 -18.40625 C 9.125 -18.429688 8.996094 -18.429688 8.839844 -18.457031 C 8.34375 -18.457031 7.851562 -18.484375 7.382812 -18.484375 C 7.148438 -18.484375 6.941406 -18.457031 6.734375 -18.457031 C 6.523438 -18.484375 6.421875 -18.40625 6.316406 -18.222656 C 6.238281 -18.09375 6.1875 -17.960938 6.109375 -17.804688 C 5.847656 -17.234375 5.535156 -16.714844 5.355469 -16.089844 C 5.148438 -15.414062 4.835938 -14.765625 4.496094 -14.117188 C 3.898438 -12.917969 3.328125 -11.699219 2.753906 -10.476562 C 2.417969 -9.824219 2.132812 -9.175781 1.84375 -8.5 C 1.742188 -8.292969 1.664062 -8.109375 1.535156 -7.929688 C 1.378906 -7.71875 1.246094 -7.488281 1.273438 -7.199219 C 1.300781 -7.019531 1.246094 -6.8125 1.222656 -6.601562 C 1.117188 -5.953125 1.039062 -5.277344 1.066406 -4.601562 C 1.066406 -4.339844 1.144531 -4.238281 1.378906 -4.183594 C 1.535156 -4.132812 1.714844 -4.160156 1.871094 -4.160156 C 2.261719 -4.183594 2.625 -4.238281 2.988281 -4.210938 C 3.847656 -4.210938 4.707031 -4.183594 5.5625 -4.160156 C 5.769531 -4.132812 5.980469 -4.132812 6.160156 -4.132812 C 6.265625 -4.132812 6.316406 -4.082031 6.316406 -3.976562 C 6.316406 -3.484375 6.289062 -2.988281 6.289062 -2.523438 C 6.289062 -1.742188 6.265625 -0.960938 6.265625 -0.183594 C 6.265625 0.339844 6.421875 0.441406 6.914062 0.390625 C 7.277344 0.363281 7.667969 0.339844 8.058594 0.3125 C 8.449219 0.3125 8.839844 0.3125 9.253906 0.339844 C 9.4375 0.339844 9.566406 0.261719 9.671875 0.128906 C 9.773438 0 9.800781 -0.15625 9.800781 -0.285156 C 9.800781 -1.039062 9.824219 -1.792969 9.824219 -2.546875 L 9.824219 -3.796875 C 9.824219 -3.898438 9.824219 -3.976562 9.957031 -3.976562 C 10.320312 -3.976562 10.65625 -4.003906 11.023438 -4.003906 C 11.386719 -4.027344 11.75 -4.054688 12.113281 -4.054688 C 12.164062 -4.054688 12.21875 -4.082031 12.269531 -4.082031 C 12.398438 -4.105469 12.476562 -4.183594 12.503906 -4.316406 C 12.53125 -4.394531 12.554688 -4.472656 12.554688 -4.550781 C 12.554688 -5.457031 12.53125 -6.34375 12.53125 -7.226562 C 12.53125 -7.304688 12.503906 -7.355469 12.503906 -7.433594 C 12.453125 -7.617188 12.347656 -7.695312 12.164062 -7.71875 C 11.800781 -7.71875 11.464844 -7.71875 11.101562 -7.746094 C 10.734375 -7.773438 10.398438 -7.773438 10.035156 -7.796875 C 9.878906 -7.796875 9.851562 -7.796875 9.851562 -7.953125 C 9.824219 -8.214844 9.824219 -8.472656 9.824219 -8.734375 C 9.800781 -10.136719 9.800781 -11.515625 9.800781 -12.917969 Z M 5.226562 -8.085938 C 5.613281 -8.785156 5.902344 -9.539062 6.34375 -10.242188 C 6.367188 -10.191406 6.367188 -10.164062 6.367188 -10.136719 C 6.394531 -9.488281 6.394531 -8.839844 6.394531 -8.1875 C 6.394531 -8.109375 6.367188 -8.03125 6.265625 -8.03125 L 5.277344 -8.03125 C 5.25 -8.03125 5.25 -8.058594 5.226562 -8.085938 Z M 5.226562 -8.085938 "
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb577c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.933016, 590.794609)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.71875 -3.429688 L 5.71875 -3.484375 C 6.058594 -3.925781 6.421875 -4.367188 6.785156 -4.808594 C 6.914062 -4.964844 7.042969 -5.121094 7.175781 -5.304688 C 7.566406 -5.875 7.953125 -6.445312 8.394531 -7.019531 C 8.863281 -7.695312 9.253906 -8.394531 9.539062 -9.175781 C 9.824219 -9.980469 9.957031 -10.839844 10.035156 -11.699219 C 10.113281 -12.582031 10.058594 -13.4375 9.902344 -14.324219 C 9.800781 -14.84375 9.671875 -15.363281 9.410156 -15.855469 C 9.253906 -16.167969 9.046875 -16.429688 8.839844 -16.714844 C 8.550781 -17.105469 8.265625 -17.441406 7.902344 -17.78125 C 7.488281 -18.171875 7.019531 -18.429688 6.445312 -18.457031 C 6.34375 -18.457031 6.238281 -18.484375 6.136719 -18.507812 C 5.746094 -18.585938 5.355469 -18.558594 4.964844 -18.558594 C 4.914062 -18.558594 4.859375 -18.558594 4.835938 -18.535156 C 4.496094 -18.40625 4.183594 -18.300781 3.875 -18.144531 C 3.613281 -18.039062 3.40625 -17.910156 3.171875 -17.78125 C 3.066406 -17.730469 2.964844 -17.703125 2.859375 -17.625 C 2.597656 -17.417969 2.367188 -17.128906 2.183594 -16.820312 C 1.921875 -16.375 1.691406 -15.933594 1.480469 -15.46875 C 1.402344 -15.285156 1.351562 -15.078125 1.300781 -14.894531 C 1.273438 -14.84375 1.273438 -14.792969 1.273438 -14.738281 C 1.378906 -14.425781 1.507812 -14.117188 1.871094 -14.011719 C 2.523438 -13.828125 3.144531 -13.621094 3.796875 -13.4375 C 3.925781 -13.386719 4.082031 -13.386719 4.210938 -13.386719 C 4.316406 -13.363281 4.394531 -13.414062 4.417969 -13.515625 C 4.496094 -13.671875 4.574219 -13.828125 4.679688 -13.984375 C 4.808594 -14.269531 4.992188 -14.53125 5.277344 -14.6875 C 5.433594 -14.765625 5.589844 -14.816406 5.746094 -14.816406 C 6.109375 -14.765625 6.394531 -14.582031 6.550781 -14.246094 C 6.707031 -13.960938 6.785156 -13.648438 6.785156 -13.335938 C 6.835938 -12.710938 6.734375 -12.113281 6.550781 -11.515625 C 6.34375 -10.945312 6.082031 -10.398438 5.824219 -9.824219 C 5.589844 -9.304688 5.277344 -8.8125 4.9375 -8.34375 C 4.550781 -7.851562 4.183594 -7.355469 3.847656 -6.835938 C 3.429688 -6.210938 3.015625 -5.589844 2.46875 -5.09375 C 1.976562 -4.628906 1.613281 -4.054688 1.222656 -3.484375 C 1.195312 -3.457031 1.195312 -3.429688 1.167969 -3.378906 C 1.144531 -3.121094 1.089844 -2.886719 1.089844 -2.652344 C 1.066406 -2.234375 1.039062 -1.84375 1.039062 -1.429688 C 1.039062 -1.039062 1.039062 -0.675781 1.066406 -0.285156 C 1.066406 -0.0507812 1.167969 0.0507812 1.378906 0.078125 C 1.480469 0.105469 1.613281 0.105469 1.714844 0.105469 L 3.796875 0.105469 C 4.78125 0.105469 5.769531 0.105469 6.734375 0.128906 C 7.617188 0.15625 8.472656 0.128906 9.332031 0.128906 C 9.4375 0.128906 9.539062 0.128906 9.644531 0.105469 C 9.878906 0.078125 9.957031 -0.0273438 9.957031 -0.261719 L 9.957031 -0.492188 C 9.980469 -1.222656 9.980469 -1.921875 10.007812 -2.652344 C 10.007812 -2.78125 9.957031 -2.886719 9.929688 -3.015625 C 9.902344 -3.171875 9.800781 -3.25 9.644531 -3.273438 C 9.4375 -3.328125 9.203125 -3.351562 8.96875 -3.351562 C 8.085938 -3.378906 7.175781 -3.378906 6.265625 -3.378906 C 6.082031 -3.378906 5.902344 -3.40625 5.71875 -3.429688 Z M 5.71875 -3.429688 "
  }))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb577c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.276766, 1146.433009)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.71875 -12.6875 C 5.746094 -12.789062 5.746094 -12.894531 5.769531 -12.972656 C 5.847656 -13.386719 5.953125 -13.777344 6.03125 -14.191406 C 6.082031 -14.402344 6.082031 -14.402344 6.265625 -14.425781 C 6.679688 -14.480469 7.121094 -14.558594 7.539062 -14.609375 C 8.007812 -14.660156 8.472656 -14.660156 8.96875 -14.6875 C 9.359375 -14.714844 9.773438 -14.738281 10.164062 -14.765625 C 10.476562 -14.816406 10.578125 -14.921875 10.605469 -15.234375 L 10.605469 -15.363281 C 10.605469 -15.988281 10.605469 -16.585938 10.632812 -17.207031 C 10.632812 -17.390625 10.605469 -17.597656 10.578125 -17.78125 C 10.578125 -17.988281 10.425781 -18.171875 10.269531 -18.171875 C 9.929688 -18.195312 9.59375 -18.25 9.226562 -18.25 C 8.449219 -18.273438 7.695312 -18.300781 6.914062 -18.300781 C 5.667969 -18.300781 4.445312 -18.328125 3.199219 -18.328125 C 3.144531 -18.328125 3.09375 -18.300781 3.042969 -18.273438 C 2.9375 -18.171875 2.808594 -18.066406 2.78125 -17.882812 C 2.78125 -17.78125 2.753906 -17.675781 2.730469 -17.574219 C 2.625 -16.820312 2.546875 -16.089844 2.417969 -15.335938 C 2.234375 -14.269531 2.027344 -13.230469 1.820312 -12.164062 C 1.664062 -11.28125 1.535156 -10.425781 1.457031 -9.539062 L 1.457031 -9.304688 C 1.457031 -9.226562 1.480469 -9.148438 1.585938 -9.125 L 2.132812 -8.96875 C 2.367188 -8.890625 2.574219 -8.8125 2.808594 -8.761719 C 3.121094 -8.65625 3.429688 -8.527344 3.796875 -8.5 C 3.976562 -8.5 4.160156 -8.421875 4.316406 -8.394531 C 4.394531 -8.371094 4.445312 -8.34375 4.523438 -8.34375 C 4.652344 -8.292969 4.757812 -8.371094 4.835938 -8.472656 C 4.964844 -8.628906 5.09375 -8.785156 5.199219 -8.941406 C 5.382812 -9.148438 5.613281 -9.253906 5.847656 -9.332031 C 6.472656 -9.539062 7.175781 -9.203125 7.410156 -8.628906 C 7.460938 -8.5 7.539062 -8.34375 7.589844 -8.214844 C 7.902344 -7.199219 7.953125 -6.210938 7.773438 -5.171875 C 7.71875 -4.730469 7.566406 -4.339844 7.277344 -3.976562 C 7.097656 -3.742188 6.890625 -3.5625 6.578125 -3.535156 C 6.316406 -3.484375 6.058594 -3.484375 5.769531 -3.507812 C 5.613281 -3.507812 5.457031 -3.5625 5.304688 -3.640625 C 4.835938 -3.898438 4.417969 -4.261719 4.132812 -4.730469 C 3.976562 -5.042969 3.847656 -5.382812 3.71875 -5.691406 C 3.640625 -5.902344 3.664062 -5.875 3.429688 -5.875 C 3.378906 -5.875 3.300781 -5.875 3.25 -5.824219 C 3.09375 -5.71875 2.9375 -5.613281 2.808594 -5.484375 C 2.46875 -5.148438 2.183594 -4.808594 1.871094 -4.472656 C 1.636719 -4.210938 1.402344 -3.953125 1.167969 -3.71875 C 1.066406 -3.613281 1.039062 -3.507812 1.089844 -3.378906 C 1.117188 -3.328125 1.144531 -3.25 1.167969 -3.199219 C 1.535156 -2.625 1.820312 -2 2.289062 -1.507812 C 2.289062 -1.480469 2.3125 -1.457031 2.3125 -1.457031 C 2.496094 -1.167969 2.703125 -0.960938 2.9375 -0.753906 C 3.378906 -0.363281 3.925781 -0.105469 4.496094 0.078125 C 4.9375 0.207031 5.40625 0.3125 5.875 0.363281 C 6.367188 0.414062 6.863281 0.390625 7.355469 0.3125 C 7.796875 0.261719 8.214844 0.078125 8.605469 -0.128906 C 8.996094 -0.339844 9.359375 -0.597656 9.59375 -0.960938 C 9.851562 -1.351562 10.085938 -1.769531 10.320312 -2.183594 C 10.476562 -2.445312 10.578125 -2.730469 10.683594 -3.015625 C 11.023438 -3.925781 11.230469 -4.859375 11.308594 -5.824219 C 11.410156 -6.914062 11.386719 -8.007812 11.203125 -9.097656 C 11.074219 -9.75 10.867188 -10.371094 10.503906 -10.917969 C 10.347656 -11.179688 10.164062 -11.410156 9.980469 -11.644531 C 9.75 -11.984375 9.410156 -12.242188 9.046875 -12.425781 C 8.527344 -12.6875 8.007812 -12.839844 7.410156 -12.867188 C 6.964844 -12.894531 6.5 -12.867188 6.058594 -12.761719 C 5.953125 -12.738281 5.847656 -12.710938 5.71875 -12.6875 Z M 5.71875 -12.6875 "
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb577c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.487704, 776.007561)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.941406 -10.007812 C 8.996094 -10.007812 9.019531 -10.035156 9.046875 -10.035156 C 9.515625 -10.503906 9.878906 -11.023438 10.058594 -11.671875 C 10.214844 -12.269531 10.292969 -12.839844 10.347656 -13.4375 C 10.371094 -13.828125 10.371094 -14.246094 10.347656 -14.636719 C 10.292969 -15.207031 10.136719 -15.753906 9.902344 -16.300781 C 9.695312 -16.765625 9.382812 -17.207031 9.070312 -17.625 C 8.96875 -17.78125 8.8125 -17.882812 8.628906 -17.988281 C 8.550781 -18.015625 8.472656 -18.066406 8.394531 -18.117188 C 8.109375 -18.351562 7.746094 -18.484375 7.410156 -18.558594 C 6.707031 -18.742188 6.03125 -18.792969 5.304688 -18.714844 C 4.652344 -18.636719 4.027344 -18.507812 3.457031 -18.195312 C 3.199219 -18.066406 2.910156 -17.910156 2.703125 -17.730469 C 2.3125 -17.363281 2.027344 -16.921875 1.792969 -16.429688 C 1.558594 -15.910156 1.324219 -15.390625 1.167969 -14.84375 C 1.117188 -14.636719 1.066406 -14.425781 1.066406 -14.21875 C 1.039062 -14.011719 1.117188 -13.90625 1.324219 -13.882812 C 1.664062 -13.855469 2 -13.804688 2.339844 -13.75 C 2.730469 -13.726562 3.121094 -13.671875 3.507812 -13.648438 C 3.691406 -13.621094 3.898438 -13.648438 4.105469 -13.648438 C 4.238281 -13.648438 4.289062 -13.699219 4.339844 -13.828125 C 4.445312 -14.0625 4.574219 -14.269531 4.679688 -14.503906 C 4.886719 -14.945312 5.25 -15.179688 5.691406 -15.257812 C 6.160156 -15.363281 6.550781 -15.234375 6.757812 -14.84375 C 6.992188 -14.453125 7.121094 -14.039062 7.148438 -13.59375 C 7.175781 -13.074219 7.042969 -12.582031 6.785156 -12.140625 C 6.628906 -11.855469 6.394531 -11.722656 6.136719 -11.621094 C 5.484375 -11.410156 4.808594 -11.308594 4.132812 -11.332031 C 3.898438 -11.359375 3.71875 -11.308594 3.5625 -11.101562 C 3.457031 -10.996094 3.378906 -10.890625 3.378906 -10.710938 C 3.40625 -10.292969 3.429688 -9.902344 3.429688 -9.488281 L 3.507812 -8.394531 C 3.535156 -8.136719 3.664062 -8.03125 3.898438 -8.03125 C 4.339844 -8.007812 4.78125 -8.007812 5.199219 -7.980469 C 6.238281 -7.929688 6.707031 -7.511719 7.042969 -6.679688 C 7.277344 -6.160156 7.355469 -5.589844 7.277344 -5.015625 C 7.277344 -4.835938 7.226562 -4.628906 7.121094 -4.472656 C 6.835938 -4.054688 6.445312 -3.769531 5.925781 -3.71875 C 5.40625 -3.691406 5.015625 -3.953125 4.707031 -4.316406 C 4.472656 -4.601562 4.339844 -4.9375 4.210938 -5.304688 C 4.132812 -5.5625 4.003906 -5.613281 3.71875 -5.5625 C 3.507812 -5.535156 3.300781 -5.511719 3.066406 -5.457031 C 2.523438 -5.355469 1.949219 -5.226562 1.402344 -5.042969 C 1.167969 -4.9375 1.066406 -4.78125 1.117188 -4.523438 C 1.222656 -4.027344 1.300781 -3.535156 1.402344 -3.042969 C 1.457031 -2.675781 1.535156 -2.367188 1.691406 -2.027344 C 1.921875 -1.636719 2.183594 -1.273438 2.546875 -0.988281 C 2.597656 -0.9375 2.652344 -0.859375 2.703125 -0.804688 C 3.121094 -0.363281 3.585938 -0.0273438 4.210938 0.105469 C 4.316406 0.105469 4.394531 0.15625 4.496094 0.15625 C 4.9375 0.234375 5.382812 0.363281 5.824219 0.390625 C 6.65625 0.441406 7.488281 0.339844 8.292969 0.078125 C 8.839844 -0.128906 9.359375 -0.390625 9.75 -0.832031 C 10.058594 -1.144531 10.292969 -1.535156 10.449219 -1.949219 C 10.605469 -2.367188 10.734375 -2.808594 10.8125 -3.25 C 11.023438 -4.105469 10.96875 -4.992188 10.839844 -5.847656 C 10.761719 -6.472656 10.632812 -7.042969 10.476562 -7.640625 C 10.347656 -8.214844 10.136719 -8.785156 9.824219 -9.28125 C 9.722656 -9.4375 9.617188 -9.566406 9.460938 -9.644531 C 9.28125 -9.75 9.148438 -9.878906 8.941406 -10.007812 Z M 8.941406 -10.007812 "
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    fill: "#fb577c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.757235, 1331.645961)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.730469 -11.152344 C 4.757812 -11.28125 4.757812 -11.359375 4.757812 -11.4375 C 4.78125 -11.644531 4.835938 -11.855469 4.859375 -12.035156 C 4.964844 -12.632812 5.148438 -13.207031 5.355469 -13.777344 C 5.433594 -14.0625 5.613281 -14.296875 5.847656 -14.503906 C 5.980469 -14.609375 6.136719 -14.6875 6.316406 -14.636719 C 6.421875 -14.609375 6.523438 -14.609375 6.628906 -14.558594 C 6.8125 -14.453125 6.992188 -14.324219 7.175781 -14.191406 C 7.433594 -13.984375 7.410156 -14.039062 7.589844 -14.21875 C 8.03125 -14.660156 8.472656 -15.128906 8.996094 -15.46875 C 9.226562 -15.648438 9.410156 -15.855469 9.644531 -16.066406 C 9.695312 -16.117188 9.695312 -16.167969 9.644531 -16.246094 C 9.382812 -16.636719 9.125 -17.027344 8.8125 -17.390625 C 8.550781 -17.703125 7.824219 -18.144531 7.433594 -18.25 C 7.355469 -18.25 7.304688 -18.273438 7.253906 -18.273438 C 6.5 -18.351562 5.746094 -18.378906 4.992188 -18.25 C 4.339844 -18.117188 3.742188 -17.832031 3.300781 -17.3125 C 3.25 -17.234375 3.171875 -17.15625 3.09375 -17.078125 C 2.886719 -16.84375 2.703125 -16.585938 2.574219 -16.300781 C 2.261719 -15.492188 1.921875 -14.6875 1.742188 -13.828125 C 1.585938 -13.128906 1.457031 -12.398438 1.378906 -11.671875 C 1.324219 -11.125 1.300781 -10.554688 1.246094 -10.007812 C 1.195312 -9.125 1.089844 -8.265625 1.066406 -7.382812 C 1.039062 -6.65625 1.039062 -5.925781 1.039062 -5.199219 C 1.066406 -4.707031 1.066406 -4.210938 1.167969 -3.71875 C 1.429688 -2.523438 2 -1.480469 2.910156 -0.675781 C 3.199219 -0.414062 3.535156 -0.207031 3.898438 -0.105469 C 4.472656 0.0273438 5.042969 0.15625 5.640625 0.15625 C 6.289062 0.15625 6.914062 0.078125 7.511719 -0.15625 C 7.617188 -0.183594 7.71875 -0.234375 7.796875 -0.285156 C 8.320312 -0.648438 8.761719 -1.117188 9.046875 -1.664062 C 9.359375 -2.261719 9.617188 -2.859375 9.773438 -3.507812 C 9.902344 -4.027344 10.007812 -4.574219 10.191406 -5.070312 C 10.292969 -5.355469 10.347656 -5.640625 10.371094 -5.925781 C 10.449219 -6.445312 10.398438 -6.992188 10.347656 -7.511719 C 10.242188 -8.578125 9.929688 -9.566406 9.359375 -10.449219 C 9.253906 -10.632812 9.097656 -10.789062 8.96875 -10.945312 L 8.421875 -11.410156 C 8.085938 -11.671875 7.71875 -11.878906 7.253906 -11.855469 C 7.042969 -11.828125 6.863281 -11.855469 6.679688 -11.828125 C 6.109375 -11.777344 5.535156 -11.671875 5.070312 -11.332031 C 4.992188 -11.253906 4.859375 -11.230469 4.730469 -11.152344 Z M 7.148438 -6.03125 L 7.148438 -5.5625 C 7.175781 -5.226562 7.121094 -4.914062 7.042969 -4.601562 C 6.964844 -4.183594 6.734375 -3.847656 6.523438 -3.507812 C 6.34375 -3.25 6.109375 -3.222656 5.71875 -3.300781 C 5.5625 -3.328125 5.40625 -3.429688 5.328125 -3.585938 L 5.277344 -3.640625 C 4.914062 -4.054688 4.835938 -4.574219 4.808594 -5.09375 C 4.808594 -5.875 4.964844 -6.601562 5.304688 -7.304688 C 5.457031 -7.589844 5.667969 -7.796875 6.03125 -7.773438 C 6.160156 -7.773438 6.289062 -7.796875 6.421875 -7.796875 C 6.679688 -7.796875 6.890625 -7.695312 6.992188 -7.433594 C 7.121094 -7.226562 7.148438 -6.964844 7.175781 -6.734375 L 7.175781 -6.03125 Z M 7.148438 -6.03125 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.3224157df6aee11e0672f04325a26c98.svg";
export { ForwardRef as ReactComponent };